import { h, FunctionComponent } from 'preact';
import { useRef } from 'preact/hooks';
import { isFirefox } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { currDocRefSelector } from '~src/domains/common/state/commonSelectors';
import SimpleButton from './Button';

/** Button that opens the document in a new window for printing. */
const DocumentPrint: FunctionComponent = () => {
  const newWindow = useRef(null) as any;
  const { t } = useTranslation();
  const currDocRef = useSelector(currDocRefSelector);

  const clickHandler = () => {
    const origin = window.location.origin;
    const pathname = window.location.pathname;
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute(
      'href',
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/css/bootstrap.min.css',
    );
    const docContent = currDocRef && currDocRef.innerHTML;
    const titles = currDocRef && currDocRef.querySelectorAll('.title');
    const titleString =
      titles &&
      Array.from(titles)
        .map(element => element.textContent)
        .join(', ');
    const content =
      currDocRef &&
      `<html>
        <head>
          <link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/css/bootstrap.min.css\">
          <title>${titleString}</title>
        </head>
        <body>
          ${docContent}
        </body>
        </html>`;

    if (!content) {
      return;
    }

    newWindow.current = window.open('', isFirefox ? origin : '_blank');
    newWindow.current.document.write(content);

    if (isFirefox) {
      window.history.pushState({}, '', pathname);
    }

    newWindow.current.document.close();
  };

  return (
    <SimpleButton
      label={t('common:document-view.buttons.print.label')}
      onClickPost={clickHandler}
      shouldTrackClick={false}
    />
  );
};

export default DocumentPrint;
